import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEslgamingComponent } from './simple-icons-eslgaming.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEslgamingComponent ],
    exports:      [ SimpleIconsEslgamingComponent ],
    bootstrap:    []
})
export class SimpleIconsEslgamingModule {}
